/* @jsxImportSource react */

import React from 'react';
import { cn } from '../../../utils/cn/cn';

/**
 * The dialog content container
 */
const DialogContent = ({ children, className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    {...props}
    className={cn('flex-auto overflow-y-auto overscroll-contain px-[20px] py-3', className)}
  >
    {children}
  </div>
);

DialogContent.displayName = 'DialogContent';

export { DialogContent };
